import { render, staticRenderFns } from "./DescuentoPlazoModal.vue?vue&type=template&id=0c62b766"
import script from "./DescuentoPlazoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DescuentoPlazoModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports